<template>
  <div class="action-record-table">
    <div class="flex-between" style="margin-bottom: 5px">
      <span class="title-1">{{ title }}</span>
      <!-- <span style="color: #2a82e4; cursor: pointer" @click="viewModal">
        查看详情
        <a-icon type="right" />
      </span> -->
    </div>
    <TableList
      style="width: 100%"
      :pagination="ipagination"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
      @change="handleTableChange"
    />

    <div v-if="showTip" class="tip" style="margin: 12px 0 5px">
      <span>
        <img
          src="@/assets/imgs/school/monthRecord/warn.png"
          alt=""
          style="width: 16px; height: 16px; margin-right: 5px"
        />
        对于未登录使用的班级，建议各级校领导立即督促班主任进行跟进处理，限期2个工作日内完成处理。
      </span>
    </div>
    <!--详情模态框-->
    <DetailModal ref="detailModalRef" :title="title" :columns="columns" :url="url" />
  </div>
</template>
<script>
import TableList from '@comp/chart/TableList.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DetailModal from '@views/school/PsychologicalMonthReport/components/DetailModal.vue'

export default {
  name: 'ActionRecordTable',
  mixins: [JeecgListMixin],
  components: {
    DetailModal,
    TableList,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    // 是否显示底部提示
    showTip: {
      type: Boolean,
      default: false,
    },
    // 有提醒未处理班级列表
    url: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      disableMixinCreated: true,
      queryParam: {}
    }
  },
  methods: {
    getLoadData(queryParam) {
      this.queryParam = queryParam
      this.loadData(1)
    },
    viewModal() {
      this.$refs.detailModalRef.showModal(this.queryParam)
    },
  },
}
</script>
<style scoped lang="less">
.action-record-table {
  .tip {
    padding: 15px;
    border-radius: 10px;
    line-height: 1.8;
    background-color: #fef2f2;
  }
}
</style>
